import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import { useContext } from '../Context';
import Form from '../Form/Index';

export default function EditModal({ affiliateTrainingStep, show, onHide }) {
  const { dispatch, actions } = useContext();

  const onSave = (formData, successCallback, errorCallback) => {
    actions.update(
      dispatch,
      affiliateTrainingStep.id,
      formData,
      () => {
        swal('Affiliate Training Step Updated');
        successCallback();
      },
      errorCallback,
    );
  };

  return (
    <Modal
      className="student inmodal auto without-overflow"
      show={show}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Update &ldquo;
          {affiliateTrainingStep.attributes.title}
          &rdquo;
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form
          affiliateTrainingStep={affiliateTrainingStep}
          onSave={onSave}
          onHide={onHide}
        />
      </Modal.Body>
    </Modal>
  );
}

EditModal.propTypes = {
  affiliateTrainingStep: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};
